"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = require("react-dropzone");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _dialog = _interopRequireDefault(require("../../_common/dialog"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Renders a drag-and-drop area that users can drag files into
 *
 * TODO: Make button work
 *
 * @param accept        An array of file types to accept
 * @param onDrop        The callback function triggered when files are dropped or picked from the file input
 * @param loading       If true the widget renders a CircularProgress bar
 * @returns {XML}
 */
var DropZone = function DropZone(_ref) {
  var accept = _ref.accept,
      onDrop = _ref.onDrop,
      loading = _ref.loading,
      outline = _ref.outline;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showNotSupportedDialog = _useState2[0],
      setShowNotSupportedDialog = _useState2[1]; // const onDropCallback = useCallback(acceptedFiles => {
  //     onDrop(acceptedFiles);
  // }, []);  // eslint-disable-line react-hooks/exhaustive-deps


  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: accept,
    onDropAccepted: onDrop,
    onDropRejected: function onDropRejected() {
      setShowNotSupportedDialog(true);
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, getRootProps(), {
    className: "drop-zone-container flex center ".concat(outline ? " drop-zone-container-outlined" : "")
  }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), isDragActive ? /*#__PURE__*/_react.default.createElement("div", {
    className: "drop-zone-title"
  }, "You got this :)") : /*#__PURE__*/_react.default.createElement("div", null, loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 40
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "drop-zone-title"
  }, "Drag 'n' drop files here"), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, "-- or --"), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary"
  }, "click to select files")))), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    title: "File Not Supported",
    open: showNotSupportedDialog,
    onClose: function onClose() {
      setShowNotSupportedDialog(false);
    },
    actions: [{
      label: 'OK',
      onClick: function onClick() {
        setShowNotSupportedDialog(false);
      }
    }]
  }, /*#__PURE__*/_react.default.createElement("div", null, "Sorry, the file type chosen is not supported")));
};

DropZone.propTypes = {
  accept: _propTypes.default.string,
  onDrop: _propTypes.default.func.isRequired,
  loading: _propTypes.default.bool.isRequired
};
var _default = DropZone;
exports.default = _default;